import { posthog } from 'posthog-js';

export type FeatureFlags = {} & Record<string, boolean | string | undefined>;

export const getCastedFeatureFlag = <T extends keyof FeatureFlags>(
  key: T,
  originalValue?: string | boolean | undefined
) => {
  const value = posthog.getFeatureFlag(key, { send_event: false }) as FeatureFlags[T];

  if (!value && value !== originalValue) {
    posthog.getFeatureFlag(key, { send_event: true }); // Report to posthog that we got a new value here
  }

  return value;
};
